import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    nuevosUsuarios: {
        result:[],
        totalPages: 0,
        currentPage: 0,
    },
    usuarios: {
        result:[],
        totalPages: 0,
        currentPage: 0,
    },
    localidades:[],
    usuario: {},
    roles: [],
    usuarioHabilitado: false,
})

export default function usuarioReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SET_NUEVOS_USUARIOS){
        return state.setIn(["nuevosUsuarios"], action.payload)
    }
    if(action.type === ReducerActions.SET_USUARIOS){
        return state
        .setIn(["usuarios"], action.payload)
        .setIn(["usuario"], {})
    }
    if(action.type === ReducerActions.SET_USUARIO_HABILITADO){
        if (action.id)
        return state.setIn(["usuarioHabilitado"], action.success)
                .setIn(["usuarios","result", state.usuarios.result.findIndex(x=> x.id === action.id), "habilitado" ], action.success)
        else
        return state.setIn(["usuarioHabilitado"], action.success)
    }
    if(action.type === ReducerActions.SAVE_USUARIO){
        return state.setIn(["usuario"], action.payload.usuario)
        .setIn(["roles"], action.payload.roles)
    }
    if(action.type === ReducerActions.SAVE_LOCALIDADES){
        return state.setIn(["localidades"], action.payload)
    }
    return state
}